export default __webpack_public_path__ + "ba2fef0a5a1cb34ff9b6f58c4300aed2.png";